import { useState, useEffect } from 'react';
import { X, TrendingDown, Receipt } from 'lucide-react';

// Venda recebida com item abaixo da política de preços (mesma regra do Simulador de
// Viabilidade de Preço) ou tabela de preço usada com mais parcelas do que permite.
export default function NotificacaoVendaAbaixoPolitica({ notificacao, onClose }) {
  const [tempoRestante, setTempoRestante] = useState(90);
  const d = notificacao.dados;

  useEffect(() => {
    const t = setInterval(() => {
      setTempoRestante(prev => {
        if (prev <= 1) { clearInterval(t); onClose(); return 0; }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(t);
  }, [onClose]);

  const fmt = (val) =>
    Number(val).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  return (
    <div className="w-96 bg-white rounded-xl shadow-2xl border-2 border-amber-400 overflow-hidden animate-slide-in">
      {/* Header */}
      <div className="bg-gradient-to-r from-amber-400 to-amber-600 px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center flex-shrink-0">
            <TrendingDown className="w-6 h-6 text-amber-500" />
          </div>
          <div className="text-white">
            <h3 className="font-bold text-base leading-tight">Venda abaixo da política!</h3>
            <p className="text-xs opacity-80">{d.forma_pagamento}</p>
          </div>
        </div>
        <button onClick={onClose} className="text-white hover:bg-white/20 rounded-lg p-1.5 transition-colors">
          <X className="w-5 h-5" />
        </button>
      </div>

      {/* Conteúdo */}
      <div className="p-4 space-y-3">
        <div className="bg-amber-50 rounded-lg p-3 border border-amber-200">
          <div className="flex items-center gap-2 text-amber-700 text-xs mb-1">
            <Receipt className="w-3.5 h-3.5" />
            Venda
          </div>
          <p className="font-bold text-gray-900 text-2xl">{d.sequencia}</p>
          {d.vendedor && <p className="text-xs text-gray-500 mt-1">Vendedor: {d.vendedor}</p>}
          {d.recebido_por && <p className="text-xs text-gray-500">Recebido por: {d.recebido_por}</p>}
        </div>

        <div className="space-y-1.5 max-h-64 overflow-y-auto">
          {(d.itens || []).map((it, idx) => (
            <div key={idx} className="bg-amber-50 border border-amber-200 rounded-lg px-3 py-2">
              <p className="text-xs font-semibold text-gray-800 truncate">
                {it.codigo_produto} — {it.nome_produto}
              </p>
              {it.tipo_alerta === 'tabela_parcelas' ? (
                <p className="text-xs text-amber-700 mt-0.5">
                  Tabela "{it.nome_tabela}" (até {it.limite_parcelas_tabela}x) vendida em {it.parcelas}x
                </p>
              ) : (
                <>
                  <div className="flex items-center justify-between mt-0.5">
                    <span className={`text-xs font-medium px-1.5 py-0.5 rounded ${it.resultado === 'inviavel' ? 'bg-red-600 text-white' : 'bg-amber-100 text-amber-800'}`}>
                      {it.resultado === 'inviavel' ? 'Inviável' : 'Liberação do gerente'}
                    </span>
                    <span className="text-xs text-gray-600">
                      R$ {fmt(it.preco_vendido)} <span className="text-gray-400">/ sug. R$ {fmt(it.preco_sugerido)}</span>
                    </span>
                  </div>
                  <p className="text-[11px] text-gray-500 mt-0.5">
                    {(it.desconto_pct * 100).toFixed(1)}% abaixo do sugerido
                    {' · '}
                    {it.motivo ? `Liberado: ${it.motivo}` : 'Sem liberação registrada'}
                  </p>
                </>
              )}
            </div>
          ))}
        </div>

        {/* Barra de progresso */}
        <div className="w-full bg-gray-100 rounded-full h-1.5">
          <div
            className="bg-amber-400 h-1.5 rounded-full transition-all duration-1000 ease-linear"
            style={{ width: `${(tempoRestante / 90) * 100}%` }}
          />
        </div>
        <p className="text-xs text-gray-400 text-center">Fechará em {tempoRestante}s</p>
      </div>
    </div>
  );
}
